<div class="field" [class.invalid]="invalid()" [class.disabled]="disabled()"
  cdkOverlayOrigin #origin="cdkOverlayOrigin" (click)="openPicker()">
  <input #input type="text" class="field-input" [attr.inputmode]="inputMode()" autocomplete="off"
    [value]="text()"
    [disabled]="disabled()"
    [readonly]="!allowTyping()"
    [placeholder]="placeholderText()"
    (input)="type($any($event.target).value)"
    (blur)="commit()"
    (keydown.enter)="commitOnEnter($event)"/>

  @if (showClear()) {
    <button type="button" class="clear" tabindex="-1" (click)="clear(); $event.stopPropagation()">
      <i class="material-icons-outlined">close</i>
    </button>
  }

  <i class="material-icons suffix">calendar_today</i>
</div>

<ng-template cdkConnectedOverlay appOverlayPanel
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="open()"
  [panelPositions]="positions"
  (panelClose)="closePicker()">
  <app-date-picker [value]="value()" [min]="min()" [max]="max()" (dateSelect)="select($event)"/>
</ng-template>
